import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface TituloPantallaProps {
  /** Rótulo chico arriba, en mayúsculas espaciadas (ej. el nombre del desarrollo). */
  antetitulo?: ReactNode;
  /** Primera parte del título. */
  titulo: ReactNode;
  /** Segunda parte, en terracota (`primario`) y en otra línea, como "Elegí / tu unidad". */
  destacado?: ReactNode;
  /** Bajada debajo del título. */
  children?: ReactNode;
  className?: string;
}

/** Encabezado de una pantalla con la línea de la presentación de Newbery 3563: rótulo, título fino y grande, bajada. */
export function TituloPantalla({ antetitulo, titulo, destacado, children, className }: TituloPantallaProps) {
  return (
    <header className={cn("flex flex-col gap-3", className)}>
      {antetitulo && <p className="text-[0.6875rem] font-medium uppercase tracking-[0.28em] text-texto-suave">{antetitulo}</p>}
      <h1 className="text-[clamp(2.25rem,5.5vw,3.5rem)] font-light leading-[1.02] tracking-[-0.03em]">
        {titulo}
        {destacado && <span className="block text-primario">{destacado}</span>}
      </h1>
      {children && <div className="max-w-xl text-texto-suave">{children}</div>}
    </header>
  );
}

export interface RotuloProps {
  children: ReactNode;
  como?: "h2" | "h3" | "p";
  className?: string;
}

/** Rótulo de una sección (ej. "Últimas novedades"): chico, en el color primario y en mayúsculas espaciadas. */
export function Rotulo({ children, como: Tag = "h2", className }: RotuloProps) {
  return <Tag className={cn("text-[0.6875rem] font-semibold uppercase tracking-[0.22em] text-primario", className)}>{children}</Tag>;
}
